// TES-1019 (Emelie, point 2) — "En ny AI-körning får inte skriva över hans ändringar utan tydlig varning och bekräftelse."
// Whether applying an AI draft to a box would replace text the doctor wrote
// himself. Only machine text may be replaced without asking: an empty box,
// the box exactly as the prefill filled it, or the box exactly as the last
// AI draft he applied left it. Anything else is his edit, and the panel
// asks before replacing it.
//
// Pure on purpose: no React, no path aliases. The unit tests in
// `apps/admin/test` run it with plain `node --test`.

function norm(text: string | null | undefined): string {
  return (text ?? "").replace(/\r\n?/g, "\n").trim();
}

export function aiApplyNeedsConfirm(box: {
  /** The box's text as it stands on screen, saved or not. */
  current: string;
  /** The prefill the box was built from (its source lines as text). */
  prefill: string | null;
  /** The AI text last applied to this box, if any. */
  lastApplied: string | null;
}): boolean {
  const current = norm(box.current);
  if (current === "") return false;
  if (box.prefill !== null && current === norm(box.prefill)) return false;
  if (box.lastApplied !== null && current === norm(box.lastApplied)) {
    return false;
  }
  return true;
}

// TES-1312 — a box that still holds exactly the deterministic prefill it was
// built from (raw "label: value (source date)" lines, TES-1050): nobody has
// written in it, cleared it or applied an AI draft to it. Only such a box is
// summarised automatically before the note is composed.
export function isUntouchedPrefill(box: {
  current: string;
  prefill: string | null;
}): boolean {
  const current = norm(box.current);
  return (
    current !== "" && box.prefill !== null && current === norm(box.prefill)
  );
}

// TES-1128 — the neutral line under an AI draft whose guarded sentences the
// server removed (`removedSentences`). Null when nothing was removed, or when
// an older API answers without the count. Emelie's copy, verbatim (Ö-364).
export function removedSentencesNote(
  removed: number | undefined,
): string | null {
  if (!removed || removed < 1) return null;
  return removed === 1
    ? "En mening togs bort eftersom den inte hade stöd i underlaget."
    : `${removed} meningar togs bort eftersom de inte hade stöd i underlaget.`;
}
